import React from 'react';

const useConst = <T extends any>(initialState: T | (() => T)): T => {
  const [value] = React.useState(initialState);
  return value;
};

export default useConst;
